module.exports = __webpack_public_path__ + "img/partner13.74c4739d.png";